import { useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Alert from "@mui/material/Alert";
import { fixSpaces } from "../../../../../shared/util/helperFunctions";

import "./ModalMotivoCancelamentoEntradas.scss";

const motivosCancelamento = [
  { cod: 2, description: "Retificação - Art.º 65, n.º 2 CIVA" },
  { cod: 3, description: "Retificação - Art.º 65, n.º 3 CIVA" },
  { cod: 6, description: "Retificação - Art.º 65, n.º 6 CIVA" },
  { cod: 7, description: "Retificação - Art.º 65, n.º 7 CIVA" },
  { cod: 8, description: "Retificação - Art.º 65, n.º 8 CIVA" },
  { cod: 9, description: "Retificação - Art.º 65, n.º 9 CIVA" },
];

const MOTIVOS_CONTINGENCIA = [
  { codigo: 1, label: "Indisponibilidade do serviço de autorização de DFEs" },
  { codigo: 2, label: "Falta de energia elétrica no estabelecimento" },
  { codigo: 3, label: "Indisponibilidade do sistema do contribuinte" },
  { codigo: 4, label: "Indisponibilidade de conexão Internet" },
  { codigo: 5, label: "Indisponibilidade do serviço de TimeStamp" },
  { codigo: 0, label: "Outro (especificar)" },
];

function ModalMotivoCancelamentoEntradas({
  open,
  handleCloseModal,
  modalData,
  handleCancelarRecebimentoEntradaClienteFornecedor,
  emitirNCE,
}) {
  const [motivoCancelamento, setMotivoCancelamento] = useState(
    motivosCancelamento[0],
  );
  const [erro, setErro] = useState("");
  const [outro, setOutro] = useState("");
  const [motivoEvent, setMotivoEvent] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [valorCancelar, setValorCancelar] = useState(
    modalData.entrada?.valor || 0,
  );

  // Contingência (apenas para NCE quando doc original em contingência)
  const documentoOriginalEmContingencia =
    modalData.documentoEmContingencia || false;
  const [motivoContingenciaSelecionado, setMotivoContingenciaSelecionado] =
    useState(1);
  const [descricaoContingenciaOutro, setDescricaoContingenciaOutro] =
    useState("");

  const motivosCancelamentoChangeHandler = (e) => {
    const selectedMotivo = motivosCancelamento.find(
      (m) => m.cod === parseInt(e.target.value),
    );
    setMotivoCancelamento(selectedMotivo);
  };

  const beforeSubmitHandler = () => {
    if (
      (motivoCancelamento.cod === 0 &&
        fixSpaces(outro).length < 10 &&
        modalData.tipoDocumento !== "Event") ||
      (fixSpaces(motivoEvent).length < 10 &&
        modalData.tipoDocumento === "Event")
    ) {
      setErro(
        `Deve indicar pelo menos 10 carateres no campo (Descrição de Motivo de Emissão de ${modalData.tipoDocumento})`,
      );
    } else if (
      modalData.apenasEmitir &&
      (!valorCancelar ||
        valorCancelar <= 0 ||
        valorCancelar > modalData.entrada?.valor)
    ) {
      setErro(
        `Valor a cancelar deve ser entre 1 e ${modalData.entrada?.valor}$00`,
      );
    } else if (
      documentoOriginalEmContingencia &&
      motivoContingenciaSelecionado === 0 &&
      descricaoContingenciaOutro.trim().length < 10
    ) {
      setErro(
        "Descrição do motivo de contingência deve ter pelo menos 10 caracteres!",
      );
    } else {
      setIsSubmitting(true);
      submitHandler();
    }
  };

  const submitHandler = () => {
    setIsSubmitting(true);

    // Preparar dados de contingência se aplicável
    const dadosContingencia = documentoOriginalEmContingencia
      ? {
          ReasonTypeCode: motivoContingenciaSelecionado,
          ReasonDescription:
            motivoContingenciaSelecionado === 0
              ? descricaoContingenciaOutro.trim()
              : MOTIVOS_CONTINGENCIA.find(
                  (m) => m.codigo === motivoContingenciaSelecionado,
                )?.label,
        }
      : null;

    if (modalData.apenasEmitir) {
      emitirNCE(
        modalData.entrada._id,
        motivoCancelamento,
        valorCancelar,
        dadosContingencia,
      );
    } else {
      handleCancelarRecebimentoEntradaClienteFornecedor(
        modalData.entrada,
        true,
        fixSpaces(motivoEvent),
      );
    }

    setIsSubmitting(false);
    handleCloseModal();
  };

  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        className="fluxo-atendimento__modal__box motivoCancelamento__modal"
        id="modal__motivoCancelamento"
      >
        <h1 className="fluxo-atendimento__modal__titulo">
          Anular {modalData.tipoDocumentoAnular} - Motivo emissão de{" "}
          {modalData.tipoDocumento}
        </h1>

        <div className="motivoCancelamento__modal__container">
          {modalData.apenasEmitir && (
            <div className="form-input" style={{ marginTop: "20px" }}>
              <input
                id="valorCancelar"
                name="valorCancelar"
                type="number"
                placeholder="0"
                value={valorCancelar}
                onChange={(e) => {
                  const valor = parseFloat(e.target.value);

                  if (isNaN(valor) || e.target.value === "") {
                    setValorCancelar("");
                  } else if (valor > modalData.entrada.valor) {
                    setValorCancelar(modalData.entrada.valor);
                  } else if (valor < 0) {
                    setValorCancelar(0);
                  } else {
                    setValorCancelar(valor);
                  }
                }}
                className="input"
                step="1"
                min="0"
                max={modalData.entrada?.valor}
              />
              <label className="label" htmlFor="valorCancelar">
                Valor a Cancelar (máx: {modalData.entrada?.valor}$00)
              </label>
            </div>
          )}

          {modalData.tipoDocumento === "Event" ? (
            <textarea
              className="motivoCancelamento__modal__textarea"
              cols={4}
              rows={4}
              onChange={(e) => setMotivoEvent(e.target.value)}
              value={motivoEvent}
              placeholder="Descrição do motivo de emissão do Evento"
            />
          ) : (
            <>
              <select
                onChange={motivosCancelamentoChangeHandler}
                className="motivoCancelamento__modal__select"
              >
                {motivosCancelamento.map((m) => (
                  <option key={m.cod} value={m.cod}>
                    {m.description}
                  </option>
                ))}
              </select>

              {motivoCancelamento.cod === 0 && (
                <>
                  <textarea
                    className="motivoCancelamento__modal__textarea"
                    cols={4}
                    rows={4}
                    onChange={(e) => setOutro(e.target.value)}
                    value={outro}
                    placeholder={`Descrição do motivo de emissão de ${modalData.tipoDocumento}`}
                  />
                  <span className="motivoCancelamento__modal__motivoStringLenght">
                    {outro.length}{" "}
                    {outro.length === 1 ? "caracter" : "caracteres"}
                  </span>
                </>
              )}

              {documentoOriginalEmContingencia &&
                modalData.tipoDocumento === "NCE" && (
                  <>
                    <Alert severity="warning" sx={{ mt: 2, mb: 2 }}>
                      O documento a cancelar foi emitido em{" "}
                      <strong>contingência</strong>. A Nota de Crédito será
                      também emitida em modo de contingência.
                    </Alert>

                    <div
                      className="customInputContainer"
                      style={{ marginBottom: "15px" }}
                    >
                      <select
                        className="customInputSelect"
                        value={motivoContingenciaSelecionado}
                        onChange={(e) =>
                          setMotivoContingenciaSelecionado(
                            Number(e.target.value),
                          )
                        }
                      >
                        {MOTIVOS_CONTINGENCIA.map((motivo) => (
                          <option key={motivo.codigo} value={motivo.codigo}>
                            {motivo.label}
                          </option>
                        ))}
                      </select>
                      <label className="customInputLabelSelect">
                        Motivo da Contingência *
                      </label>
                    </div>

                    {motivoContingenciaSelecionado === 0 && (
                      <textarea
                        className="motivoCancelamento__modal__textarea"
                        cols={4}
                        rows={3}
                        onChange={(e) =>
                          setDescricaoContingenciaOutro(e.target.value)
                        }
                        value={descricaoContingenciaOutro}
                        placeholder="Especifique o motivo da emissão em contingência (mínimo 10 caracteres)..."
                      />
                    )}
                  </>
                )}
            </>
          )}
        </div>

        <div className="motivoCancelamento__modal__erro">{erro && erro}</div>

        <div
          style={{
            gridColumn: "1/-1",
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
          }}
        >
          <span
            className="cancel-btn"
            onClick={handleCloseModal}
            style={{ display: "block" }}
          >
            Fechar
          </span>

          <span
            className="blue-button"
            disabled={isSubmitting}
            onClick={beforeSubmitHandler}
          >
            {isSubmitting ? "Guardando..." : "Guardar"}
          </span>
        </div>
      </Box>
    </Modal>
  );
}

export default ModalMotivoCancelamentoEntradas;
